import { barChartLabelFormatter } from "@/common/utils/barChartLabelFormatter";
import { translateSeriesName } from "@/common/utils/seriesNameTranslator";
import { DashboardComponentData } from "@/features/company/types/dashboards/dashboardComponent.type";
import { TooltipContentProps } from "recharts";

interface ChartTooltipProps extends Partial<TooltipContentProps> {
  chartData: DashboardComponentData['data'];
}

export const ChartTooltip = ({
  active,
  payload,
  label,
  chartData,
}: ChartTooltipProps) => {
  if (!active || !payload?.length) return null;

  const seriesSettings = chartData.series_settings;

  const filteredPayload = payload.filter(item => item?.value != null);

  if (!filteredPayload.length) return null;

  return (
    <div className="bg-slate-300 rounded-lg px-3 py-2 text-[12px] text-black shadow-[0_2px_6px_rgba(0,0,0,0.15)] space-y-1">
      <p className="font-semibold" data-testid="chart_tooltip_label">
        {label}
      </p>

      {filteredPayload.map((item, i) => (
        <div key={i} className="flex items-center gap-1">
          <div className="w-2 h-2 rounded-full" style={{ backgroundColor: item.color }} />

          <span data-testid={`chart_tooltip_value_${item.name}`}>
            {translateSeriesName(item.name as string || "")}:{" "}

            {barChartLabelFormatter(item.value as string ?? 0, seriesSettings[item.dataKey as keyof typeof seriesSettings || ""]?.format_parser)}
          </span>
        </div>
      ))}
    </div>
  );
}

export default ChartTooltip;

